import { successNotify } from '../../components/NotificationsEmitter';

const SuccessDataSaveNotify = (message?: string) =>
  successNotify('Успешно', message || 'Данные были успешно сохранены');
export default SuccessDataSaveNotify;
